module.exports = __webpack_public_path__ + "img/pic13.8601cb19.png";